/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Card,
  CardContent,
  Grid,
  Autocomplete,
  TextField
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import RolePermAction from '../../store/actions/RolePermAction';
import ContentLoader from '../../utils/errorPages/ContentLoader';
import IOSSwitchStyle from '../../components/SwitchField';
import UserAction from '../../store/actions/UserAction';

export default function PermissionsComponent() {
  const [data, setData] = React.useState([]);
  const [isUserRole, setIsUserRole] = useState(false);
  // const [permissionData, setPermissionData] = React.useState([]);
  const [activeRole, setActiveRole] = React.useState([]);
  const [activeUser, setActiveUser] = React.useState([]);
  const [roleValue, setRoleValue] = React.useState(null);
  const [userValue, setUserValue] = React.useState(null);
  const [permissionArray, setPermissionArray] = React.useState([]);
  const [userPermissionArray, setUserPermissionArray] = React.useState([]);
  const [allModule, setAllModule] = React.useState([]);

  console.log(allModule, 'allModule');

  const dispatch = useDispatch();
  const { permAllData, activeRoleData, permItemData, isLoading } = useSelector(
    (state) => state.rolePermission
  ); // Replace 'data' with your reducer name
  const { activeUserData } = useSelector((state) => state.user); // Replace 'data' with your reducer name

  useEffect(() => {
    dispatch(RolePermAction.getAllPermissions());
    dispatch(RolePermAction.getActiveItem());
    dispatch(UserAction.getActiveItem());
  }, [dispatch]);

  useEffect(() => {
    // Extract keys from the provided object and create an initial state object
    const initialState = Object.keys(permAllData).reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {});

    // Update the state
    setAllModule([initialState]);
  }, [permAllData]);

  useEffect(() => {
    if (permAllData && permItemData && permAllData !== undefined && permItemData !== undefined) {
      const newIds = [];
      const newuserIds = [];
      const updateState = () => {
        const updatedData = { ...permAllData }; // Create a copy of the current state

        // Iterate over the keys of updatedData using Object.keys()
        Object.keys(updatedData).forEach((key1) => {
          if (Object.prototype.hasOwnProperty.call(permItemData, key1)) {
            updatedData[key1] = updatedData[key1].map((item1) => {
              const matchedItem = permItemData[key1].find((item2) => item1.name === item2.name);
              const newItem = { ...item1 }; // Clone item1 to avoid modifying it directly
              if (matchedItem && matchedItem?.flag) {
                newItem.flag = matchedItem?.flag;
                if (matchedItem.flag === 'user') {
                  newuserIds.push(newItem._id);
                }
              } else {
                newItem.flag = false;
              }
              const matchingItem = permItemData[key1].some((item2) => item1.name === item2.name);
              if (matchingItem) {
                newIds.push(newItem._id);
              }

              return { ...newItem, checked: matchingItem };
            });

            const allChecked = updatedData[key1].every((subItem) => subItem.checked);

            setAllModule((prevModules) => {
              const updatedModules = [...prevModules];
              return updatedModules.map((moduleObj) => {
                if (Object.prototype.hasOwnProperty.call(moduleObj, key1)) {
                  return { ...moduleObj, [key1]: allChecked };
                }
                return moduleObj; // Ensure a value is always returned
              });
            });
          } else {
            updatedData[key1] = updatedData[key1].map((item1) => {
              return { ...item1, checked: false, flag: false };
            });
            setAllModule((prevModules) => {
              const updatedModules = [...prevModules];
              return updatedModules.map((moduleObj) => {
                if (Object.prototype.hasOwnProperty.call(moduleObj, key1)) {
                  return { ...moduleObj, [key1]: false };
                }
                return moduleObj; // Ensure a value is always returned
              });
            });
          }
        });
        // Update the state with modified object1
        setData(updatedData);
        // Update permissionArray state
        setPermissionArray(newIds);
        setUserPermissionArray(newuserIds);
      };
      // Call the updateState function whenever component mounts or object1 changes
      updateState();
    }
    if (activeRoleData) {
      setActiveRole(activeRoleData);
    }
    if (activeUserData) {
      setActiveUser(activeUserData);
    }
    // if (permItemData) {
    //   setPermissionData(permItemData);
    // }
  }, [permAllData, activeRoleData, activeUserData, permItemData]);

  // Function to handle switch toggle
  const handleSwitchToggle = (e, module, permissionId, permissionName) => {
    const newPermissionId = [];
    if (e.target.checked) {
      let listId;
      let updatedPermissionArray;
      let updatedUserPermissionArray;
      setData((prevData) => {
        const updatedData = {
          ...prevData,
          [module]: prevData[module].map((subItem) => {
            if (subItem._id === permissionId) {
              return { ...subItem, checked: e.target.checked };
            }
            if (
              permissionName.includes('store') ||
              permissionName.includes('update') ||
              permissionName.includes('show') ||
              permissionName.includes('destroy')
            ) {
              if (subItem.name.includes('index')) {
                listId = subItem._id;
                return { ...subItem, checked: e.target.checked };
              }
            }

            return subItem;
          })
        };
        const allChecked = updatedData[module].every((subItem) => subItem.checked);
        if (allChecked) {
          setAllModule((prevModules) =>
            prevModules.map((moduleObj) => {
              if (Object.prototype.hasOwnProperty.call(moduleObj, module)) {
                return { ...moduleObj, [module]: true };
              }
              return moduleObj;
            })
          );
        }

        updatedPermissionArray = listId
          ? [...permissionArray, permissionId, listId]
          : [...permissionArray, permissionId];
        updatedUserPermissionArray = listId
          ? [...userPermissionArray, permissionId, listId]
          : [...userPermissionArray, permissionId];
        if (isUserRole) {
          setUserPermissionArray(updatedUserPermissionArray);
        } else {
          setPermissionArray(updatedPermissionArray);
        }

        return updatedData;
      });
      if (roleValue?._id) {
        const formData = {
          permissions: updatedPermissionArray
        };
        dispatch(RolePermAction.assignPermission(roleValue._id, 'role', formData)); // Use optional chaining directly
      } else if (userValue?._id) {
        const formData = {
          permissions: updatedUserPermissionArray
        };
        dispatch(RolePermAction.assignPermission(userValue._id, 'user', formData)); // Use userValue here
      }
    } else {
      newPermissionId.push(permissionId);
      setData((prevData) => {
        const updatedData = {
          ...prevData,
          [module]: prevData[module].map((subItem) => {
            if (subItem._id === permissionId) {
              return { ...subItem, checked: e.target.checked };
            }
            // if (
            //   permissionName.includes('store') &&
            //   permissionName.includes('update') &&
            //   permissionName.includes('show') &&
            //   permissionName.includes('destroy')
            // ) {
            //   if (subItem.name.includes('index')) {
            //     console.log(subItem._id, 'subItem');
            //     return { ...subItem, checked: e.target.checked };
            //   }
            // } else
            if (permissionName.includes('index')) {
              if (subItem.checked) {
                newPermissionId.push(subItem._id);
              }
              if (
                subItem.name.includes('store') ||
                subItem.name.includes('update') ||
                subItem.name.includes('show') ||
                subItem.name.includes('destroy')
              ) {
                return { ...subItem, checked: e.target.checked };
              }
            }

            return subItem;
          })
        };
        console.log('🚀 ~ [module]:prevData[module].map ~ newPermissionId:', newPermissionId);
        const allChecked = updatedData[module].every((subItem) => subItem.checked);
        if (!allChecked) {
          setAllModule((prevModules) =>
            prevModules.map((moduleObj) => {
              if (Object.prototype.hasOwnProperty.call(moduleObj, module)) {
                return { ...moduleObj, [module]: false };
              }
              return moduleObj;
            })
          );
        }
        if (isUserRole) {
          // userPermissionArray.filter((value) => value !== !newPermissionId.includes(id))
          setUserPermissionArray((prevArray) =>
            prevArray.filter((id) => !newPermissionId.includes(id))
          );
        } else {
          // permissionArray.filter((value) => value !== !newPermissionId.includes(id))
          setPermissionArray((prevArray) =>
            prevArray.filter((id) => !newPermissionId.includes(id))
          );
        }
        return updatedData;
      });
      if (roleValue?._id) {
        const newIds = permissionArray.filter((value) => !newPermissionId.includes(value));
        const values = [...newIds];
        const formData = {
          permissions: values
        };
        dispatch(RolePermAction.assignPermission(roleValue._id, 'role', formData)); // Use optional chaining directly
      } else if (userValue?._id) {
        const newIds = userPermissionArray.filter((value) => !newPermissionId.includes(value));
        const values = [...newIds];
        const formData = {
          permissions: values
        };
        dispatch(RolePermAction.assignPermission(userValue._id, 'user', formData)); // Use userValue here
      }
    }
  };

  const handleAllSwitchToggle = (e, module, modulePermission) => {
    let newIds = [];
    let newUserIds = [];
    if (e.target.checked) {
      // Extract _id from modulePermission
      const modulePermissionIds = modulePermission.map((item) => item._id);

      console.log('🚀 ~ handleAllSwitchToggle ~ modulePermissionIds:', modulePermissionIds);
      console.log('🚀 ~ handleAllSwitchToggle ~ userPermissionArray:', userPermissionArray);

      // Filter out ids that already exist in permissionArray
      if (isUserRole) {
        const uniqueIdsToAdd = modulePermissionIds.filter(
          (id) => !userPermissionArray.includes(id)
        );
        console.log('🚀 ~ handleAllSwitchToggle ~ uniqueIdsToAdd:', uniqueIdsToAdd);
        // Concatenate unique ids with permissionArray
        newUserIds = [...userPermissionArray, ...uniqueIdsToAdd];
        console.log('🚀 ~ handleAllSwitchToggle ~ newUserIds:', newUserIds);
        setUserPermissionArray(newUserIds);
      } else {
        const uniqueIdsToAdd = modulePermissionIds.filter((id) => !permissionArray.includes(id));
        // Concatenate unique ids with permissionArray
        newIds = [...permissionArray, ...uniqueIdsToAdd];
        setPermissionArray(newIds);
      }

      setAllModule((prevModules) =>
        prevModules.map((moduleName) => {
          // If the module name matches the current module, set its value to true
          if (Object.prototype.hasOwnProperty.call(moduleName, module)) {
            return { ...moduleName, [module]: true };
          }
          return moduleName; // Otherwise, return the module unchanged
        })
      );
      setData((prevData) => ({
        ...prevData,
        [module]: prevData[module].map((subItem) => {
          // const isNameMatched = modulePermission.some((item) => item.name === subItem.name);
          return {
            ...subItem,
            checked: e.target.checked
          };
        })
      }));
      // setPermissionArray((prevArray) => [...prevArray, ...newIds]);

      if (roleValue?._id) {
        const formData = {
          permissions: newIds
        };
        dispatch(RolePermAction.assignPermission(roleValue._id, 'role', formData)); // Use optional chaining directly
      } else if (userValue?._id) {
        const formData = {
          permissions: newUserIds
        };
        dispatch(RolePermAction.assignPermission(userValue._id, 'user', formData)); // Use userValue here
      }
    } else {
      setAllModule((prevModules) =>
        prevModules.map((moduleName) => {
          // If the module name matches the current module, set its value to true
          if (Object.prototype.hasOwnProperty.call(moduleName, module)) {
            return { ...moduleName, [module]: false };
          }
          return module; // Otherwise, return the module unchanged
        })
      );
      setData((prevData) => ({
        ...prevData,
        [module]: prevData[module].map((subItem) => ({
          ...subItem,
          checked: false
        }))
      }));

      if (isUserRole) {
        newUserIds = userPermissionArray.filter(
          (id) => !modulePermission.map((item) => item._id).includes(id)
        );
        setUserPermissionArray(newUserIds);
      } else {
        newIds = permissionArray.filter(
          (id) => !modulePermission.map((item) => item._id).includes(id)
        );
        setPermissionArray(newIds);
      }
      if (roleValue?._id) {
        const formData = {
          permissions: [...newIds]
        };
        dispatch(RolePermAction.assignPermission(roleValue._id, 'role', formData)); // Use optional chaining directly
      } else if (userValue?._id) {
        const formData = {
          permissions: [...newUserIds]
        };
        dispatch(RolePermAction.assignPermission(userValue._id, 'user', formData)); // Use userValue here
      }
    }
  };

  const handleRoleOnChange = (event, newValue) => {
    setRoleValue(newValue);
    // Clear the value of Autocomplete 2 when a selection is made in Autocomplete 1
    if (newValue?._id) {
      dispatch(RolePermAction.getPermissions(newValue._id, 'roles')); // Use optional chaining directly
    }
    setIsUserRole(false);
    setUserValue(null);
  };

  const handleUserOnChange = (event, newValue) => {
    setUserValue(newValue);
    // Clear the value of Autocomplete 1 when a selection is made in Autocomplete 2
    if (newValue?._id) {
      dispatch(RolePermAction.getPermissions(newValue._id, 'user-all-permission')); // Use userValue here
    }
    setIsUserRole(true);
    setRoleValue(null);
  };

  const formatString = (str) => {
    return str
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // console.log('🚀 ~ handleSwitchToggle ~ permissionArray:', permissionArray);
  // console.log('🚀 ~ handleSwitchToggle ~ data:', data);

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <Card className="pageTitleWrap" sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={6}>
            <Grid item md={4} xs={4}>
              <Autocomplete
                className="CurrencyField"
                value={roleValue}
                isOptionEqualToValue={(option, value) => option.name === value.name}
                popupIcon={<ExpandMore />}
                options={activeRole}
                onChange={handleRoleOnChange}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option._id}>
                      {option.name}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="name"
                    label="Role"
                    placeholder="Search Role"
                    variant="outlined"
                    margin="normal"
                  />
                )}
              />
            </Grid>
            <Grid item md={4} xs={4}>
              <Autocomplete
                className="CurrencyField"
                options={activeUser}
                isOptionEqualToValue={(option, value) => option.name === value.name}
                popupIcon={<ExpandMore />}
                value={userValue}
                // disableClearable
                onChange={handleUserOnChange}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option._id}>
                      {option.name}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="name"
                    label="User"
                    placeholder="Search User"
                    variant="outlined"
                    margin="normal"
                  />
                )}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {roleValue?._id || userValue?._id ? (
        <Box
          sx={{
            bgcolor: 'white',
            position: 'relative',
            overflow: 'hidden'
          }}
          className="dataTable__wrap"
        >
          {isLoading ? <ContentLoader /> : ''}
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Module</TableCell>
                  <TableCell align="center">All</TableCell>
                  <TableCell align="center">List</TableCell>
                  <TableCell align="center">Create</TableCell>
                  <TableCell align="center">Edit</TableCell>
                  <TableCell align="center">View</TableCell>
                  <TableCell align="center">Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(data).map((module, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {formatString(module)}
                    </TableCell>
                    <TableCell align="center">
                      <IOSSwitchStyle
                        checked={allModule[0][module]}
                        className={
                          isUserRole && data[module].some((item) => item.flag === 'role')
                            ? 'switchRed'
                            : ''
                        }
                        disabled={isUserRole && data[module].some((item) => item.flag === 'role')}
                        value={module ?? ''}
                        onChange={(e) => handleAllSwitchToggle(e, module, data[module])}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </TableCell>
                    {data[module].map((permission, idx) => {
                      return (
                        permission.name.includes('index') && (
                          <TableCell key={idx} align="center">
                            <IOSSwitchStyle
                              checked={permission.checked}
                              className={
                                isUserRole && permission.flag === 'role' ? 'switchRed' : ''
                              }
                              disabled={isUserRole && permission.flag === 'role'}
                              value={permission._id ?? ''}
                              onChange={(e) =>
                                handleSwitchToggle(e, module, permission._id, permission.name)
                              }
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </TableCell>
                        )
                      );
                    })}
                    {data[module].map((permission, idx) => {
                      return (
                        permission.name.includes('store') && (
                          <TableCell key={idx} align="center">
                            <IOSSwitchStyle
                              checked={permission.checked}
                              className={
                                isUserRole && permission.flag === 'role' ? 'switchRed' : ''
                              }
                              disabled={isUserRole && permission.flag === 'role'}
                              value={permission._id ?? ''}
                              onChange={(e) =>
                                handleSwitchToggle(e, module, permission._id, permission.name)
                              }
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </TableCell>
                        )
                      );
                    })}
                    {data[module].map((permission, idx) => {
                      return (
                        permission.name.includes('update') && (
                          <TableCell key={idx} align="center">
                            <IOSSwitchStyle
                              checked={permission.checked}
                              className={
                                isUserRole && permission.flag === 'role' ? 'switchRed' : ''
                              }
                              disabled={isUserRole && permission.flag === 'role'}
                              value={permission._id ?? ''}
                              onChange={(e) =>
                                handleSwitchToggle(e, module, permission._id, permission.name)
                              }
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </TableCell>
                        )
                      );
                    })}
                    {data[module].map((permission, idx) => {
                      return (
                        permission.name.includes('show') && (
                          <TableCell key={idx} align="center">
                            <IOSSwitchStyle
                              checked={permission.checked}
                              className={
                                isUserRole && permission.flag === 'role' ? 'switchRed' : ''
                              }
                              disabled={isUserRole && permission.flag === 'role'}
                              value={permission._id ?? ''}
                              onChange={(e) =>
                                handleSwitchToggle(e, module, permission._id, permission.name)
                              }
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </TableCell>
                        )
                      );
                    })}
                    {data[module].map((permission, idx) => {
                      return (
                        permission.name.includes('destroy') && (
                          <TableCell key={idx} align="center">
                            <IOSSwitchStyle
                              checked={permission.checked}
                              className={
                                isUserRole && permission.flag === 'role' ? 'switchRed' : ''
                              }
                              disabled={isUserRole && permission.flag === 'role'}
                              value={permission._id ?? ''}
                              onChange={(e) =>
                                handleSwitchToggle(e, module, permission._id, permission.name)
                              }
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </TableCell>
                        )
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        ''
      )}
    </Box>
  );
}
